import { Component, Input } from '@angular/core';

@Component({
  selector: 'hc-requirement',
  templateUrl: './requirement.component.html',
  styleUrls: ['./requirement.component.scss']
})
export class RequirementComponent {

  constructor() { }

}
